import moment from 'moment'

// The label/value pairs both reservation modals show. One place, so the details modal and
// the cancel modal can't drift into describing the same booking differently.
//
// Takes the shape the calendar hands over: a FullCalendar-ish event with `start` and
// `extendedProps`. Blank facts are dropped rather than rendered as "-": a half-filled
// summary reads as a loading state on a screen you're meant to act on.
export default function reservationFacts(date) {
  const { dateType, label, partySize } = date?.extendedProps || {}

  return [
    { label: 'When', value: date?.start ? moment(date.start).format('dddd D MMMM YYYY, HH:mm') : '' },
    { label: 'Date type', value: dateType },
    { label: 'Reservation', value: label },
    { label: 'Table size', value: partySize ? `${partySize} ${partySize === 1 ? 'person' : 'persons'}` : '' },
  ].filter(fact => fact.value)
}
